import React from "react";

export default function StreamBox({ text, streaming, label = "Output Stream" }) {
  return (
    <div className="brutal-border bg-[#0A0A0A] relative" data-testid="stream-box">
      <div className="flex items-center justify-between px-4 py-2 border-b border-white/10 bg-[#141414]">
        <div className="flex items-center gap-2">
          <div className={`w-2 h-2 ${streaming ? "bg-signal-yellow animate-pulse" : "bg-zinc-600"}`} />
          <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-zinc-400">{label}</span>
        </div>
        <span className="font-mono text-[10px] text-zinc-600">{streaming ? "LIVE" : text ? "READY" : "IDLE"}</span>
      </div>
      <div className="p-6 min-h-[260px] max-h-[60vh] overflow-auto">
        {text ? (
          <pre className="font-mono text-sm leading-relaxed text-zinc-200 whitespace-pre-wrap break-words">
            {text}
            {streaming && <span className="cursor-blink" />}
          </pre>
        ) : (
          <div className="font-mono text-xs text-zinc-600">
            // awaiting input. press <span className="kbd">GENERATE</span> to start the engine.
          </div>
        )}
      </div>
    </div>
  );
}

export function PlatformPicker({ value, onChange, name = "platform-picker" }) {
  const options = [
    { v: "tiktok", l: "TikTok" },
    { v: "reels", l: "Reels" },
    { v: "shorts", l: "Shorts" },
    { v: "twitter", l: "Twitter/X" },
    { v: "linkedin", l: "LinkedIn" },
  ];
  return (
    <div className="grid grid-cols-2 sm:grid-cols-5 gap-2" data-testid={name}>
      {options.map((o) => (
        <button
          key={o.v}
          type="button"
          data-testid={`${name}-${o.v}`}
          onClick={() => onChange(o.v)}
          className={`px-3 py-2 border font-mono text-[11px] uppercase tracking-[0.2em] transition-colors ${
            value === o.v
              ? "bg-signal-yellow text-black border-signal-yellow"
              : "bg-transparent text-zinc-400 border-white/15 hover:border-white/40 hover:text-white"
          }`}
        >
          {o.l}
        </button>
      ))}
    </div>
  );
}

export function PrimaryButton({ children, ...props }) {
  return (
    <button
      {...props}
      className={`bg-signal-yellow text-black font-bold uppercase tracking-[0.18em] text-xs px-6 py-3 hover:bg-signal-yellow-hover transition-colors disabled:opacity-40 disabled:cursor-not-allowed ${props.className || ""}`}
    >
      {children}
    </button>
  );
}

export function GhostButton({ children, ...props }) {
  return (
    <button
      {...props}
      className={`bg-transparent border border-white/15 text-zinc-300 font-mono text-[11px] uppercase tracking-[0.18em] px-4 py-2 hover:border-white/40 hover:text-white transition-colors disabled:opacity-40 ${props.className || ""}`}
    >
      {children}
    </button>
  );
}

export function TextInput({ label, hint, ...props }) {
  return (
    <label className="block space-y-2">
      {label && <span className="label-eyebrow block">{label}</span>}
      <input
        {...props}
        className={`w-full bg-[#141414] border border-white/10 text-white placeholder:text-zinc-600 focus:border-signal-yellow focus:outline-none focus:ring-1 focus:ring-signal-yellow transition-all p-3 font-mono text-sm ${props.className || ""}`}
      />
      {hint && <span className="font-mono text-[10px] text-zinc-600">{hint}</span>}
    </label>
  );
}

export function TextArea({ label, hint, ...props }) {
  return (
    <label className="block space-y-2">
      {label && <span className="label-eyebrow block">{label}</span>}
      <textarea
        {...props}
        className={`w-full bg-[#141414] border border-white/10 text-white placeholder:text-zinc-600 focus:border-signal-yellow focus:outline-none focus:ring-1 focus:ring-signal-yellow transition-all p-4 font-mono text-sm min-h-[140px] ${props.className || ""}`}
      />
      {hint && <span className="font-mono text-[10px] text-zinc-600">{hint}</span>}
    </label>
  );
}
